module.exports = __webpack_public_path__ + "static/media/Manual_Central_Online_SSAT.dd75ebef.pdf";